import { render } from "./BlogFooter.vue?vue&type=template&id=3b1a7c86"
import script from "./BlogFooter.vue?vue&type=script&lang=js"
export * from "./BlogFooter.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__